export default {
  BASE_URL: "https://production.finitetime.io/",
};
